import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { AppBar, Badge, IconButton, Toolbar, Hidden, colors } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import { PropertyPicker, FieldPicker, OrganizationPicker } from 'components';
import { useTranslation } from 'react-i18next';
import { useFields, useOrganizations, useSettings } from 'hooks';
import hostLogo from 'utils/hostLogo';
import { Roles } from 'utils/authHelpers';
import { Grid, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
    textAlign: 'center',
    display: 'flex',
    marginLeft: theme.spacing(6),
  },
  titleText: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(2),
    verticalAlign: 'middle',
  },
  notificationsButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  menuIcon: {
    marginLeft: -12,
    marginRight: theme.spacing(1),
  },
  logo: {
    height: 30,
    marginTop: theme.spacing(1),
  },
  arrow: { marginRight: 16, marginLeft: 8 },
}));

const TopBar = (props) => {
  const { onOpenSideBarMobile, className, ...rest } = props;
  const { t } = useTranslation();

  const classes = useStyles();
  const notificationsRef = useRef(null);
  const [notifications] = useState([]);
  const [setOpenNotifications] = useState(false);
  const { fields } = useFields();
  const { organizations, selectedOrganization } = useOrganizations();
  const { currentUserRoles } = useSettings();

  const matchesXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  const isLoggedIn = false;

  const handleNotificationsOpen = () => {
    setOpenNotifications(true);
  };

  const selectedOrganizationWithRole = () => {
    return (
      (_.includes(currentUserRoles, Roles.Super) && !!selectedOrganization && selectedOrganization.id) ||
      (!_.includes(currentUserRoles, Roles.Super) && selectedOrganization?.id)
    );
  };

  /* XXX Change the logo to go to About after development */
  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <Hidden lgUp>
          <IconButton onClick={onOpenSideBarMobile} className={classes.menuIcon}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <img src={hostLogo()} className={classes.logo} alt={t('brand')} />
        </RouterLink>
        {!matchesXS ? (
          <div className={classes.flexGrow}>
            <Grid container alignItems="center">
              <Grid item>
                <Typography variant="subtitle2" className={classes.titleText} marginLeft={-2}>
                  {t('global_filter')}
                </Typography>
              </Grid>
              <Grid item container direction={'row'}>
                <OrganizationPicker variant="subtitle1" />
                {!_.isEmpty(organizations) && <ChevronRightIcon color="secondary" className={classes.arrow} />}
                {selectedOrganizationWithRole() && <PropertyPicker variant="subtitle1" />}
                {selectedOrganizationWithRole() && !_.isEmpty(fields) && (
                  <ChevronRightIcon color="secondary" className={classes.arrow} />
                )}
                {selectedOrganizationWithRole() && <FieldPicker variant="subtitle1" />}
              </Grid>
            </Grid>
          </div>
        ) : (
          <div className={classes.flexGrow}>
            <OrganizationPicker variant="subtitle1" />
          </div>
        )}
        {isLoggedIn && (
          <IconButton className={classes.notificationsButton} onClick={handleNotificationsOpen} ref={notificationsRef}>
            <Badge badgeContent={notifications.length} classes={{ badge: classes.notificationsBadge }} variant="dot">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenSideBarMobile: PropTypes.func,
};

TopBar.defaultProps = {
  className: undefined,
  onOpenSideBarMobile: () => {},
};
export default TopBar;
